import enOrderStepType from "../../../api/enums/enOrderStepType";
import {PayloadAddFormData} from "../payload-add-form/PayloadAddForm";

import {keysJoin} from "fulogics-ui-core/dist/api/odata/ODataModel";
import {
    RouteLocationModelSimpleTextData,
    RouteLocationModelSimpleTextDataKeys
} from "fulogics-ui-web/dist/layout/components/route-location-model-simple-text/RouteLocationModelSimpleText";
import {IdentifiersModelSimpleTextData} from "fulogics-ui-core/dist/layout/components/identifiers-model-simple-text/IdentifiersModelSimpleText";
import {
    RouteLocationModelMultiLineData,
    RouteLocationModelMultiLineDataKeys
} from "fulogics-ui-web/dist/layout/dx/DataGrid/templates/columns/route-location-model-multi-line-column-template/RouteLocationModelMultiLineColumnTemplate";


export type OrderStepProductItemData = {
    id?: number // techniczne id fulogics
    //stockReservationId?:number, // id rezerwacji w systemie logsoft
    identifiers?: IdentifiersModelSimpleTextData,// & IdentifiersColumnData, // do tego jest już gridColumn zrobiony w core Lib
    carriers?:
        {
            id?: string,
            count?: number, // 3
            //
            payloadItemsCount?: number // ile łącznie produktów znajduje się na tych wszystkich paletach
        }
}

export type OrderForwardStepData = PayloadAddFormData & {
    id?: string,
    location?: RouteLocationModelMultiLineData,
    plannedStartDate?: Date,
    type?: enOrderStepType,
    //    
    payload?: // items OrderStepProductItemData
        {
            id?: string,
            carrierCount?: number,
        },
}

export const OrderForwardStepDataKeys = ["id",
    "plannedStartDate",
    "type",
    "payload.id",
    "payload.carrierCount",
    ...keysJoin(RouteLocationModelMultiLineDataKeys, "location.")
]